import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Param } from "../../core/context/Param";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { readOnly } from "../../core/util/Interface";
/**
 * Panner is an equal power Left/Right Panner. It is a wrapper around the StereoPannerNode.
 * @example
 * return Tone.Offline(() => {
 * // move the input signal from right to left
 * 	const panner = new Tone.Panner(1).toDestination();
 * 	panner.pan.rampTo(-1, 0.5);
 * 	const osc = new Tone.Oscillator(100).connect(panner).start();
 * }, 0.5, 2);
 * @category Component
 */

export var Panner = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Panner, _ToneAudioNode);

  var _super = _createSuper(Panner);

  function Panner() {
    var _this;

    _classCallCheck(this, Panner);

    _this = _super.call(this, Object.assign(optionsFromArguments(Panner.getDefaults(), arguments, ["pan"])));
    _this.name = "Panner";
    /**
     * the panner node
     */

    _this._panner = _this.context.createStereoPanner();
    _this.input = _this._panner;
    _this.output = _this._panner;
    var options = optionsFromArguments(Panner.getDefaults(), arguments, ["pan"]);
    _this.pan = new Param({
      context: _this.context,
      param: _this._panner.pan,
      value: options.pan,
      minValue: -1,
      maxValue: 1
    }); // this is necessary for standardized-audio-context
    // doesn't make any difference for the native AudioContext
    // https://github.com/chrisguttandin/standardized-audio-context/issues/647

    _this._panner.channelCount = options.channelCount;
    _this._panner.channelCountMode = "explicit"; // initial value

    readOnly(_assertThisInitialized(_this), "pan");
    return _this;
  }

  _createClass(Panner, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Panner.prototype), "dispose", this).call(this);

      this._panner.disconnect();

      this.pan.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        pan: 0,
        channelCount: 1
      });
    }
  }]);

  return Panner;
}(ToneAudioNode);